jQuery(function () {
    jQuery("h1 ,h2 ,h3 ,h4 ,h5 ,h6 ,p ,span, a").html(function () {
        return jQuery(this).html().replace("®", "<sup>&reg;</sup>")
    });

    jQuery("h1 ,h2 ,h3 ,h4 ,h5 ,h6 ,p ,span, a").html(function () {
        return jQuery(this).html().replace("<sup><sup>®</sup></sup>", "<sup>&reg;</sup>")
    });

    jQuery("h1 ,h2 ,h3 ,h4 ,h5 ,h6 ,p ,span, a").html(function () {
        return jQuery(this).html().replace("®&nbsp;", "<sup>&reg;</sup>&nbsp;")
    });

    jQuery("h1 ,h2 ,h3 ,h4 ,h5 ,h6 ,p ,span, a").html(function () {
        return jQuery(this).html().replace("&nbsp;®", "&nbsp;<sup>&reg;</sup>")
    });

    jQuery("a, h1").html(function () {
        return jQuery(this).html().replace("<sup>®</sup> Mastercard®", "<sup>®</sup> Mastercard<sup>®</sup>")
    });

});